export default function Search() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.92565 0C3.55699 0 0 3.55714 0 7.92565C0 12.2943 3.55714 15.8486 7.92565 15.8486C12.2942 15.8486 15.8486 12.294 15.8486 7.92565C15.8486 3.55699 12.294 0 7.92565 0ZM7.92565 1.33279C11.5741 1.33279 14.5161 4.27722 14.5161 7.92557C14.5161 11.574 11.5743 14.5161 7.92565 14.5161C4.27703 14.5161 1.33287 11.5742 1.33287 7.92557C1.33287 4.27714 4.27729 1.33279 7.92565 1.33279Z"
        fill="#F27021"
      />
      <path
        d="M13.3526 12.6868C13.1741 12.6861 13.003 12.7572 12.8775 12.8837C12.7518 13.0103 12.682 13.182 12.6841 13.3604C12.6861 13.5387 12.7594 13.7088 12.8879 13.8327L18.8609 19.8057C18.9858 19.9309 19.1553 20.0014 19.3321 20.0017C19.5091 20.0018 19.6788 19.9318 19.804 19.8069C19.9292 19.6821 19.9997 19.5125 19.9999 19.3356C20.0002 19.1587 19.9301 18.9891 19.8052 18.8638L13.8296 12.8882C13.7042 12.7594 13.5321 12.6867 13.3525 12.6865L13.3526 12.6868Z"
        fill="#F27021"
      />
    </svg>
  );
}
